import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { apiFetch, ApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ChangePasswordPage() {
  const nav = useNavigate();
  const [cur, setCur] = useState(""); const [nw, setNw] = useState(""); const [err, setErr] = useState<string | null>(null);
  const change = useMutation({
    mutationFn: () => apiFetch("/api/me/password", { method: "POST", body: JSON.stringify({ currentPassword: cur, newPassword: nw }) }),
    onSuccess: () => { void nav("/me"); },
    onError: (e) => setErr(e instanceof ApiError ? e.message : "Failed"),
  });
  return (
    <form onSubmit={(e) => { e.preventDefault(); change.mutate(); }} className="mx-auto max-w-sm space-y-3 p-6">
      <h1 className="text-2xl font-semibold">Change password</h1>
      <div><Label htmlFor="cp">Current password</Label><Input id="cp" type="password" value={cur} onChange={(e) => setCur(e.target.value)} required /></div>
      <div><Label htmlFor="np">New password (min 12 chars)</Label><Input id="np" type="password" value={nw} onChange={(e) => setNw(e.target.value)} minLength={12} required /></div>
      {err && <p role="alert" className="text-sm text-destructive">{err}</p>}
      <Button type="submit">Change password</Button>
    </form>
  );
}
